import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CheckChangePasswordResponse } from './reset-password-check-types';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FormError, GeneralError } from '../register/response-with-success.interceptor';

@Injectable({
    providedIn: 'root'
})
export class ResetPasswordCheckService {
    private readonly http: HttpClient = inject(HttpClient);
    static readonly urlCheckChangePassword: string = '/abaqus/rest_api/webapp/auth/password_check/';
    static readonly urlPasswordChange: string = '/abaqus/rest_api/webapp/auth/password_change/';

    checkChangePassword$(uid: string, token: string): Observable<CheckChangePasswordResponse> {
        let params = new HttpParams();
        if (uid) {
            params = params.append('uid_b64', uid);
        }
        if (token) {
            params = params.append('token', token);
        }
        return this.http.get<CheckChangePasswordResponse>(ResetPasswordCheckService.urlCheckChangePassword, {params});
    }

    changePassword$(uidB64: string, token: string, newPassword: string): Observable<void> {
        return this.http.post<null>(ResetPasswordCheckService.urlPasswordChange, {
            uid_b64: uidB64, token, new_password: newPassword
        }).pipe(
            map(() => void (0)),
            catchError((error: HttpErrorResponse) => this.toPasswordChangeError(error)),
        );
    }

    private toPasswordChangeError(error: HttpErrorResponse): Observable<never> {
        if (error.status === 400) {
            return throwError(() => new FormError('', this.flatErrorMessages(error.error)));
        }
        if (error.status === 403) {
            return throwError(() => new GeneralError(error.error?.detail ?? ''));
        }
        return throwError(() => error);
    }

    private flatErrorMessages(body: { [key: string]: string[] }): { [key: string]: string } {
        const formErrors: { [key: string]: string } = {};
        for (const field of Object.keys(body)) {
            formErrors[field] = body[field].join(' ');
        }
        return formErrors;
    }
}
